import { safeGet, safeRemove } from "./safeStorage";

// Retry fetch up to 2 times with delay — handles transient failures
// from dying service workers or flaky mobile connections
async function fetchWithRetry(url, options, retries = 2) {
  for (let i = 0; i <= retries; i++) {
    try {
      const res = await fetch(url, options);
      return res;
    } catch (err) {
      if (i === retries) throw err;
      await new Promise(r => setTimeout(r, 500 * (i + 1)));
    }
  }
}

export function authFetch(url, options = {}) {
  const token = safeGet("gfp_token");
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return fetchWithRetry(url, { ...options, headers });
}

export function getToken() {
  return safeGet("gfp_token");
}

export function setToken(token) {
  if (token) {
    const { safeSet } = require("./safeStorage");
    safeSet("gfp_token", token);
  }
}

export function clearToken() {
  safeRemove("gfp_token");
  safeRemove("gfp_was_authenticated");
}
